import { Injectable } from '@angular/core';
import { ReportesRequestService } from '../request/reportes-request.service';

@Injectable({
  providedIn: 'root'
})
export class ImagesService {

  constructor( private requestUrl: ReportesRequestService ) { }

  async getLogo(codigoBaseDatos: string) {
    try {
      const response = await this.requestUrl.getImagesRequest(
        'consultar/logo',
        [codigoBaseDatos]
      );
      return response;
    } catch (e) {
      console.log(`ServicioImagenes.getLogo() ${e}`);
    }
    return null;
  }

  async getFirmaProfesional(codigobaseDatos: string, uncoProfesional: number) {
    try {
      const response = await this.requestUrl.getImagesRequest(
        'consultar/firma-profesional',
        [ 
          codigobaseDatos,
          {
            uncoProfesional
          }
        ]);
        return response;
    } catch(e) {
      console.log('ServicioImagenes.getFirmaProfesional()',e);
    }
    return null;
  }
}
